import React from "react";
import { motion } from "framer-motion";

const AnimateWrapper = ({ children, motionKey, initial, animate, exit, transition, ...props }) => {
  return (
    <motion.div key={motionKey} initial={initial} animate={animate} exit={exit} transition={transition} {...props}>
      {children}
    </motion.div>
  );
};

AnimateWrapper.defaultProps = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2 },
};

export default AnimateWrapper;
